import { ContractAllocationRow } from 'components/features/contract-allocation-table/types';
import {
  EValidationSeverity,
  ValidationError,
} from 'components/ui/excel-table/types';
import { TFunction } from 'i18next';

export const validateContractAllocation = (
  row: ContractAllocationRow,
  rowIndex: number,
  data: ContractAllocationRow[],
  t: TFunction
): ValidationError<ContractAllocationRow>[] => {
  const errors: ValidationError<ContractAllocationRow>[] = [];

  // FOREX percentage validation (must be between -5% and 5%)
  if (row.forexPercentage && Math.abs(row.forexPercentage) > 5) {
    errors.push({
      field: 'forexPercentage',
      rowIndex,
      message: t('contractAllocation.forexPercentageOutOfRange'),
      severity: EValidationSeverity.SOFT,
    });
  }

  // settlement exchange rate must exist
  if (!row.settlementExchangeRate && row.isSelected) {
    errors.push({
      field: 'settlementExchangeRate',
      rowIndex,
      message: t('validation.required', {
        field: t('contractAllocation.settlementExchangeRate'),
      }),
    });
  }

  // settlement exchange rate must be > 0
  if (
    row.settlementExchangeRate &&
    (isNaN(row.settlementExchangeRate) ||
      Number(row.settlementExchangeRate) <= 0)
  ) {
    errors.push({
      field: 'settlementExchangeRate',
      rowIndex,
      message: t('validation.min', {
        field: t('contractAllocation.settlementExchangeRate'),
        min: 0,
      }),
    });
  }

  return errors;
};
